export const columnFields = [
	'takeOffType',
	'level',
	'material',
	'sku',
	'quantity',
	'uom',
	'waste',
	'usage',
	'imageName',
] as const;
